/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { BumpMarket } from "../BumpMarket";

export class BumpMarket__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BumpMarket> {
    return super.deploy(overrides || {}) as Promise<BumpMarket>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BumpMarket {
    return super.attach(address) as BumpMarket;
  }
  connect(signer: Signer): BumpMarket__factory {
    return super.connect(signer) as BumpMarket__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BumpMarket {
    return new Contract(address, _abi, signerOrProvider) as BumpMarket;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressAddedToWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "removedWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressRemovedFromWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "burnedYearnTokens",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountWithdrawn",
        type: "uint256",
      },
    ],
    name: "AmountWithdrawnFromYearn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ApprovedAmountToYearnVault",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "BumpPurchased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestRate",
        type: "uint256",
      },
    ],
    name: "DepositMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DepositedAmountToYearnVault",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "rewardee",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "RewardIssued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBumpPurchaseAllocation",
        type: "uint256",
      },
    ],
    name: "UpdatedBumpPurchaseAllocation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBumpRewardAllocation",
        type: "uint256",
      },
    ],
    name: "UpdatedBumpRewardAllocation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxBumpPercent",
        type: "uint256",
      },
    ],
    name: "UpdatedMaxBumpPercent",
    type: "event",
  },
  {
    inputs: [],
    name: "BUMP_INITAL_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BUMP_REWARDS_BONUS_DRAG",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BUMP_REWARDS_BONUS_DRAG_DIVIDER",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BUMP_REWARDS_FORMULA_CONSTANT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SWAP_RATE_CONSTANT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addAddressToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approveUSDCToYearnVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bumpPurchaseAllocation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bumpRewardAllocation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bumpTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "busdcTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentTVL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amountForBumpPurchase",
        type: "uint256",
      },
      {
        internalType: "enum BumpMarket.StableCoins",
        name: "_coin",
        type: "uint8",
      },
    ],
    name: "depositAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositDetails",
    outputs: [
      {
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositUSDCInYearnVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_totalDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amountForPurchase",
        type: "uint256",
      },
    ],
    name: "estimateBumpRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_deposit",
        type: "uint256",
      },
    ],
    name: "estimateSwapRateBumpUsdc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum BumpMarket.StableCoins",
        name: "_coin",
        type: "uint8",
      },
    ],
    name: "getCurrentPrice",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSwapRateBumpUsdc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getyUSDCIssuedToReserve",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_usdcAddresses",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "_whitelistAddresses",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_bumpTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_busdcTokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxBumpPercent",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_bumpRewardAllocation",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_bumpPurchaseAllocation",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxBumpPercent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseProtocol",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeAddressFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "swap",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseProtocol",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_bumpPurchaseAllocation",
        type: "uint256",
      },
    ],
    name: "updateBumpPurchaseAllocation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_bumpRewardAllocation",
        type: "uint256",
      },
    ],
    name: "updateBumpRewardAllocation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxBumpPercent",
        type: "uint256",
      },
    ],
    name: "updateMaxBumpPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "usdcForBumpPurchase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawUSDCFromBumperMarket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawUSDCFromYearnVault",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50612a58806100206000396000f3fe608060405234801561001057600080fd5b50600436106102275760003560e01c80637b9417c811610130578063bbc9ff48116100b8578063eebab6b71161007c578063eebab6b71461040a578063eff8fe5a14610412578063f2fde38b14610425578063f863e1d514610438578063f93b6be51461044057610227565b8063bbc9ff48146103cc578063bf3eee80146103df578063c614410e146103e7578063d90d1cb1146103ef578063dbf624891461040257610227565b80638da5cb5b116100ff5780638da5cb5b146103a157806394b918de146103a95780639d4b5a4d146103bc578063a102e6ce146103a9578063a95411e0146103c457610227565b80637b9417c81461036b5780637bf2c9151461037e57806387ed8219146103915780638b43bf451461039957610227565b806345c397eb116101b35780635c975abb116101825780635c975abb146103205780636cddad9a146103355780636f62f05a14610348578063715018a61461035b5780637b0fc03b1461036357610227565b806345c397eb146102dd578063519a7ad3146102f257806354f761c81461030557806357cb9b2e1461031857610227565b80631d8fe390116101fa5780631d8fe39014610294578063286dd3f51461029c57806332689fce146102af5780633a799748146102c2578063431f5962146102d557610227565b80630f38c0251461022c578063150bf3ca14610255578063165b92dc146102775780631973207e1461027f575b600080fd5b61023f61023a36600461204a565b610448565b60405161024c91906122ce565b60405180910390f35b61026861026336600461204a565b61045a565b60405161024c9392919061292b565b61023f61047b565b61029261028d36600461213b565b610483565b005b61023f610513565b6102926102aa36600461204a565b610518565b6102926102bd36600461218c565b6105ad565b6102926102d036600461213b565b61092a565b61023f6109a6565b6102e56109ac565b60405161024c9190612258565b61023f61030036600461216b565b6109bb565b61029261031336600461213b565b610a44565b61023f610ac0565b610328610af3565b60405161024c91906122c3565b61029261034336600461213b565b610afc565b61023f61035636600461213b565b610ba0565b610292610be4565b61023f610c6d565b61029261037936600461204a565b610cee565b61029261038c366004612064565b610d86565b6102e5610ff7565b61023f611006565b6102e561100c565b6103286103b736600461213b565b61101b565b61023f611021565b61023f611027565b61023f6103da36600461213b565b61102d565b61023f61115f565b61023f611165565b6102926103fd36600461213b565b61116b565b610292611247565b61023f6112fe565b61023f610420366004612121565b611303565b61029261043336600461204a565b6113d8565b6102e5611499565b6102926114a8565b60cb6020526000908152604090205481565b60ca6020526000908152604090208054600182015460029092015490919083565b630393870081565b60c9600061048f61155d565b6001600160a01b0316815260208101919091526040016000205460ff166104d15760405162461bcd60e51b81526004016104c890612338565b60405180910390fd5b60ce8190556040517f04962df22229ffa7422acf9997979ed896f432a9a71478eb186720b71bdb63e690610508903390849061276b565b60405180910390a150565b604481565b60c9600061052461155d565b6001600160a01b0316815260208101919091526040016000205460ff1661055d5760405162461bcd60e51b81526004016104c890612338565b6001600160a01b038116600090815260c9602052604090819020805460ff19169055517f535611fb62fa2a833988f283b779e417e996813e44046f521d76c17b5943b08c90610508908390612258565b600260655414156105d05760405162461bcd60e51b81526004016104c890612890565b60026065556105dd610af3565b156105fa5760405162461bcd60e51b81526004016104c89061259e565b60008361060984612710612979565b6106139190612959565b905060006106218486612998565b905060008060ce548411156106485760405162461bcd60e51b81526004016104c8906126b9565b33600090815260ca60205260409020600201546106a15760408051606081018252600080825260208083018781524284860190815233845260ca90925293909120915182559151600182015590516002909101556106d3565b33600090815260ca60205260409020600101546106bf908490612941565b33600090815260ca60205260409020600101555b33600090815260cb60205260409020546106ee908790612941565b33600090815260cb602052604090205560cd5461070c908890612941565b60cd556107198387611561565b809250819350505061077333308960cc60008a60405160200161073c919061222b565b60408051601f19818403018152918152815160209283012083529082019290925201600020546001600160a01b03169291906115f8565b60d3546040516340c10f1960e01b81526001600160a01b03909116906340c10f19906107a590339087906004016122aa565b600060405180830381600087803b1580156107bf57600080fd5b505af11580156107d3573d6000803e3d6000fd5b505060d2546001600160a01b03169150630bed750e9050336107f58486612941565b6040518363ffffffff1660e01b81526004016108129291906122aa565b600060405180830381600087803b15801561082c57600080fd5b505af1158015610840573d6000803e3d6000fd5b5050505061084d87611656565b610856876116de565b336001600160a01b03167f0b05f0d1cd0819f155b8a61f60baf7767c1ee49d04aeaab701df236140eb93f984600060405161089292919061291d565b60405180910390a2337fca46e5c2326c9eca7e0d946e330a087d659db7f4f04f0eb40ee3e62c7982019c836108c5610ac0565b6040516108d392919061291d565b60405180910390a2337f20d087800dde6b7dfe6af37b0e9f01feea12b908da3ee959aafceaa69cc750a282610906610ac0565b60405161091492919061291d565b60405180910390a2505060016065555050505050565b60c9600061093661155d565b6001600160a01b0316815260208101919091526040016000205460ff1661096f5760405162461bcd60e51b81526004016104c890612338565b60cf8190556040517f94e466da192610395adfb72d47a0a597e67746a5dd2b4e4079cba1c9cfabe9df9061050890339084906123c7565b612af881565b60d1546001600160a01b031681565b6000806109c784610ba0565b905060006109d58486612998565b90506000612af86109e7604488612979565b6109f69064e8d4a51000612979565b610a009190612959565b610a0e630393870085612979565b610a19906064612979565b60cf54610a269085612979565b610a309190612959565b610a3a9190612941565b9695505050505050565b60c96000610a5061155d565b6001600160a01b0316815260208101919091526040016000205460ff16610a895760405162461bcd60e51b81526004016104c890612338565b60d08190556040517f0e1871d8ffd3aaf952e20966af12fa84b5b1529a105b80a14f8786d3ec58dc1290610508903390849061241f565b600061177064174876e800600860cd54610ada9190612979565b610ae49190612959565b610aee9190612941565b905090565b60335460ff1690565b60c96000610b0861155d565b6001600160a01b0316815260208101919091526040016000205460ff16610b415760405162461bcd60e51b81526004016104c890612338565b610b49610af3565b15610b665760405162461bcd60e51b81526004016104c89061259e565b610b6f81611656565b7f360e4d6d22e49d48f81892e8a2bf2fb7fdac721d631e88c259024cd0986e63ae33826040516105089291906127b8565b6000808260cd54610bb19190612941565b905061177064174876e800610bc7600884612979565b610bd19190612959565b610bdb9190612941565b9150505b919050565b610bec61155d565b6001600160a01b0316610bfd61100c565b6001600160a01b031614610c235760405162461bcd60e51b81526004016104c89061264d565b6097546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3609780546001600160a01b0319169055565b60d1546040516370a0823160e01b81526000916001600160a01b0316906370a0823190610c9e903090600401612258565b60206040518083038186803b158015610cb657600080fd5b505afa158015610cca573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610aee9190612153565b60c96000610cfa61155d565b6001600160a01b0316815260208101919091526040016000205460ff16610d335760405162461bcd60e51b81526004016104c890612338565b6001600160a01b038116600090815260c9602052604090819020805460ff19166001179055517f534d18c8ff24ba5980906d732f3075704749427353734fbbf05d50485643b12490610508908390612258565b600054610100900460ff1680610d9f575060005460ff16155b610dbb5760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff16158015610de6576000805460ff1961ff0019909116610100171660011790555b6001600160a01b038616610e0c5760405162461bcd60e51b81526004016104c890612682565b6001600160a01b038516610e325760405162461bcd60e51b81526004016104c890612567565b610e3a611768565b610e426117ec565b610e4b87611854565b87600081518110610e6c57634e487b7160e01b600052603260045260246000fd5b602002602001015160cc600080604051602001610e89919061222b565b60405160208183030381529060405280519060200120815260200190815260200160002060000160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555087600181518110610ef557634e487b7160e01b600052603260045260246000fd5b602002602001015160cc600080604051602001610f12919061222b565b60405160208183030381529060405280519060200120815260200190815260200160002060010160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555087600281518110610f7e57634e487b7160e01b600052603260045260246000fd5b602090810291909101015160d180546001600160a01b03199081166001600160a01b039384161790915560d28054821689841617905560d3805490911691871691909117905560ce84905560cf83905560d0829055610fdb611951565b8015610fed576000805461ff00191690555b5050505050505050565b60d2546001600160a01b031681565b60cf5481565b6097546001600160a01b031690565b50600190565b60d05481565b60cd5481565b600060c9600061103b61155d565b6001600160a01b0316815260208101919091526040016000205460ff166110745760405162461bcd60e51b81526004016104c890612338565b61107c610af3565b156110995760405162461bcd60e51b81526004016104c89061259e565b60d154604051632e1a7d4d60e01b81526000916001600160a01b031690632e1a7d4d906110ca9086906004016122ce565b602060405180830381600087803b1580156110e457600080fd5b505af11580156110f8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061111c9190612153565b90507fdb11149f4da50e98c3fa4fbf6166f0ae372b105ca9ea58d5183bf1e3117c973f338483604051611151939291906124bf565b60405180910390a192915050565b60ce5481565b61177081565b60c9600061117761155d565b6001600160a01b0316815260208101919091526040016000205460ff166111b05760405162461bcd60e51b81526004016104c890612338565b600260655414156111d35760405162461bcd60e51b81526004016104c890612890565b60026065556111e0610af3565b156111fd5760405162461bcd60e51b81526004016104c89061259e565b611206816116de565b7fdf1629a17ae82369b0665c5b9b0c1744a190f217dddef1b27a56d42fe5f42ffe338260405161123792919061236f565b60405180910390a1506001606555565b60c9600061125361155d565b6001600160a01b0316815260208101919091526040016000205460ff1661128c5760405162461bcd60e51b81526004016104c890612338565b60d360009054906101000a90046001600160a01b03166001600160a01b0316638456cb596040518163ffffffff1660e01b8152600401600060405180830381600087803b1580156112dc57600080fd5b505af11580156112f0573d6000803e3d6000fd5b505050506112fc611951565b565b600881565b60008060cc60008460405160200161131b919061222b565b60405160208183030381529060405280519060200120815260200190815260200160002060010160009054906101000a90046001600160a01b031690506000816001600160a01b031663feaf968c6040518163ffffffff1660e01b815260040160a06040518083038186803b15801561139357600080fd5b505afa1580156113a7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113cb91906121c0565b5091979650505050505050565b6113e061155d565b6001600160a01b03166113f161100c565b6001600160a01b0316146114175760405162461bcd60e51b81526004016104c89061264d565b6001600160a01b03811661143d5760405162461bcd60e51b81526004016104c890612479565b6097546040516001600160a01b038084169216907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3609780546001600160a01b0319166001600160a01b0392909216919091179055565b60d3546001600160a01b031681565b60c960006114b461155d565b6001600160a01b0316815260208101919091526040016000205460ff166114ed5760405162461bcd60e51b81526004016104c890612338565b60d360009054906101000a90046001600160a01b03166001600160a01b0316633f4ba83a6040518163ffffffff1660e01b8152600401600060405180830381600087803b15801561153d57600080fd5b505af1158015611551573d6000803e3d6000fd5b505050506112fc6119c3565b3390565b600080806115786115728587612941565b85611a1a565b905060cf5481111561159c5760405162461bcd60e51b81526004016104c890612616565b8060cf546115aa9190612998565b60cf5560006115b885611a25565b905060d0548111156115dc5760405162461bcd60e51b81526004016104c89061272a565b8060d0546115ea9190612998565b60d055909590945092505050565b611650846323b872dd60e01b85858560405160240161161993929190612286565b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b031990931692909217909152611a55565b50505050565b61165e610af3565b1561167b5760405162461bcd60e51b81526004016104c89061259e565b60d1546040516116db916001600160a01b031690839060cc906000906116a590829060200161222b565b60408051601f19818403018152918152815160209283012083529082019290925201600020546001600160a01b03169190611ae9565b50565b6116e6610af3565b156117035760405162461bcd60e51b81526004016104c89061259e565b60d15460405163b6b55f2560e01b81526001600160a01b039091169063b6b55f25906117339084906004016122ce565b600060405180830381600087803b15801561174d57600080fd5b505af1158015611761573d6000803e3d6000fd5b5050505050565b600054610100900460ff1680611781575060005460ff16155b61179d5760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff161580156117c8576000805460ff1961ff0019909116610100171660011790555b6117d0611bac565b6117d8611c1f565b80156116db576000805461ff001916905550565b600054610100900460ff1680611805575060005460ff16155b6118215760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff1615801561184c576000805460ff1961ff0019909116610100171660011790555b6117d8611c9d565b600054610100900460ff168061186d575060005460ff16155b6118895760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff161580156118b4576000805460ff1961ff0019909116610100171660011790555b6118bc611bac565b6118c4611d16565b60005b825181101561193a57600160c960008584815181106118f657634e487b7160e01b600052603260045260246000fd5b6020908102919091018101516001600160a01b03168252810191909152604001600020805460ff191691151591909117905580611932816129db565b9150506118c7565b50801561194d576000805461ff00191690555b5050565b611959610af3565b156119765760405162461bcd60e51b81526004016104c89061259e565b6033805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586119ac61155d565b6040516119b99190612258565b60405180910390a1565b6119cb610af3565b6119e75760405162461bcd60e51b81526004016104c89061230a565b6033805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa6119ac61155d565b6000806109c7610ac0565b600080611a30610ac0565b611a3f8464e8d4a51000612979565b611a4b90612710612979565b610bdb9190612959565b6000611aaa826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b0316611d869092919063ffffffff16565b805190915015611ae45780806020019051810190611ac89190612101565b611ae45760405162461bcd60e51b81526004016104c890612846565b505050565b801580611b715750604051636eb1769f60e11b81526001600160a01b0384169063dd62ed3e90611b1f903090869060040161226c565b60206040518083038186803b158015611b3757600080fd5b505afa158015611b4b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b6f9190612153565b155b611b8d5760405162461bcd60e51b81526004016104c8906128c7565b611ae48363095ea7b360e01b84846040516024016116199291906122aa565b600054610100900460ff1680611bc5575060005460ff16155b611be15760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff161580156117d8576000805460ff1961ff00199091166101001716600117905580156116db576000805461ff001916905550565b600054610100900460ff1680611c38575060005460ff16155b611c545760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff16158015611c7f576000805460ff1961ff0019909116610100171660011790555b6033805460ff1916905580156116db576000805461ff001916905550565b600054610100900460ff1680611cb6575060005460ff16155b611cd25760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff16158015611cfd576000805460ff1961ff0019909116610100171660011790555b600160655580156116db576000805461ff001916905550565b600054610100900460ff1680611d2f575060005460ff16155b611d4b5760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff16158015611d76576000805460ff1961ff0019909116610100171660011790555b611d7e611bac565b6117d8611d9f565b6060611d958484600085611e6b565b90505b9392505050565b600054610100900460ff1680611db8575060005460ff16155b611dd45760405162461bcd60e51b81526004016104c8906125c8565b600054610100900460ff16158015611dff576000805460ff1961ff0019909116610100171660011790555b6000611e0961155d565b609780546001600160a01b0319166001600160a01b038316908117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a35080156116db576000805461ff001916905550565b60603031831115611e8e5760405162461bcd60e51b81526004016104c890612521565b611e9785611f2c565b611eb35760405162461bcd60e51b81526004016104c89061280f565b600080866001600160a01b03168587604051611ecf919061220f565b60006040518083038185875af1925050503d8060008114611f0c576040519150601f19603f3d011682016040523d82523d6000602084013e611f11565b606091505b5091509150611f21828286611f32565b979650505050505050565b3b151590565b60608315611f41575081611d98565b825115611f515782518084602001fd5b8160405162461bcd60e51b81526004016104c891906122d7565b80356001600160a01b0381168114610bdf57600080fd5b600082601f830112611f92578081fd5b8135602067ffffffffffffffff80831115611faf57611faf612a0c565b81830260405183828201018181108482111715611fce57611fce612a0c565b60405284815283810192508684018288018501891015611fec578687fd5b8692505b858310156120155761200181611f6b565b845292840192600192909201918401611ff0565b50979650505050505050565b803560018110610bdf57600080fd5b805169ffffffffffffffffffff81168114610bdf57600080fd5b60006020828403121561205b578081fd5b611d9882611f6b565b600080600080600080600060e0888a03121561207e578283fd5b873567ffffffffffffffff80821115612095578485fd5b6120a18b838c01611f82565b985060208a01359150808211156120b6578485fd5b506120c38a828b01611f82565b9650506120d260408901611f6b565b94506120e060608901611f6b565b9699959850939660808101359560a0820135955060c0909101359350915050565b600060208284031215612112578081fd5b81518015158114611d98578182fd5b600060208284031215612132578081fd5b611d9882612021565b60006020828403121561214c578081fd5b5035919050565b600060208284031215612164578081fd5b5051919050565b6000806040838503121561217d578182fd5b50508035926020909101359150565b6000806000606084860312156121a0578283fd5b83359250602084013591506121b760408501612021565b90509250925092565b600080600080600060a086880312156121d7578081fd5b6121e086612030565b945060208601519350604086015192506060860151915061220360808701612030565b90509295509295909350565b600082516122218184602087016129af565b9190910192915050565b60006001831061224957634e487b7160e01b81526021600452602481fd5b5060f89190911b815260010190565b6001600160a01b0391909116815260200190565b6001600160a01b0392831681529116602082015260400190565b6001600160a01b039384168152919092166020820152604081019190915260600190565b6001600160a01b03929092168252602082015260400190565b901515815260200190565b90815260200190565b60006020825282518060208401526122f68160408501602087016129af565b601f01601f19169190910160400192915050565b60208082526014908201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b604082015260600190565b60208082526019908201527f41646472657373206e6f7420696e2077686974656c6973742e00000000000000604082015260600190565b60608082526022908201527f42554d504552204465706f7369746564416d6f756e74546f596561726e5661756080820152611b1d60f21b60a08201526001600160a01b03929092166020830152604082015260c00190565b60608082526022908201527f42554d504552205570646174656442554d50526577617264416c6c6f6361746960808201526137b760f11b60a08201526001600160a01b03929092166020830152604082015260c00190565b60608082526024908201527f42554d504552205570646174656442756d705075726368617365416c6c6f63616080820152633a34b7b760e11b60a08201526001600160a01b03929092166020830152604082015260c00190565b60208082526026908201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160408201526564647265737360d01b606082015260800190565b60808082526024908201527f42554d50455220416d6f756e7457697468647261776e46726f6d596561726e5660a082015263185d5b1d60e21b60c08201526001600160a01b039390931660208401526040830191909152606082015260e00190565b60208082526026908201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6040820152651c8818d85b1b60d21b606082015260800190565b6020808252601f908201527f425553444320546f6b656e20416464726573732063616e6e6f74206265203000604082015260600190565b60208082526010908201526f14185d5cd8589b194e881c185d5cd95960821b604082015260600190565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b6020808252601d908201527f4e6f7420656e6f7567682042554d502052657761726473206c65667421000000604082015260600190565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b6020808252601e908201527f42756d7020546f6b656e20416464726573732063616e6e6f7420626520300000604082015260600190565b6020808252604b908201527f4578636565646564206d6178696d756d206465706f7369742070657263656e7460408201527f61676520746861742063616e20626520616c6c6f636174656420666f7220425560608201526a4d5020707275636861736560a81b608082015260a00190565b60208082526021908201527f4e6f7420656e6f7567682042554d50206c65667420746f2070757263686173656040820152602160f81b606082015260800190565b6060808252601c908201527f42554d50455220557064617465644d617842554d5050657263656e740000000060808201526001600160a01b03929092166020830152604082015260a00190565b60608082526021908201527f42554d50455220417070726f766564416d6f756e74546f596561726e5661756c6080820152601d60fa1b60a08201526001600160a01b03929092166020830152604082015260c00190565b6020808252601d908201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604082015260600190565b6020808252602a908201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6040820152691bdd081cdd58d8d9595960b21b606082015260800190565b6020808252601f908201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604082015260600190565b60208082526036908201527f5361666545524332303a20617070726f76652066726f6d206e6f6e2d7a65726f60408201527520746f206e6f6e2d7a65726f20616c6c6f77616e636560501b606082015260800190565b918252602082015260400190565b9283526020830191909152604082015260600190565b60008219821115612954576129546129f6565b500190565b60008261297457634e487b7160e01b81526012600452602481fd5b500490565b6000816000190483118215151615612993576129936129f6565b500290565b6000828210156129aa576129aa6129f6565b500390565b60005b838110156129ca5781810151838201526020016129b2565b838111156116505750506000910152565b60006000198214156129ef576129ef6129f6565b5060010190565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052604160045260246000fdfea264697066735822122089f6159346cc975e626ee45e5415f1cb3f6b7a2d6eb287565b9d44244d0c5d9064736f6c63430008000033";
